module.exports = __webpack_public_path__ + "static/media/Super Systems Logo.8b3adec3.jpeg";